import { closeDrawerPane } from '../orchestration/closeDrawerPane';
import openDrawerPane from '../orchestration/openDrawerPane';
import { isDrawerPaneVisible } from '../selectors/isDrawerPaneVisible';

/**
 * Toggles the visibility of a drawer pane.
 * @param paneId The unique key for the pane.
 * @param targetWindow The window where the pane should be opened. Defaults to the current window.
 * @param showAppUnderlay Optional parameter to show the app pane as an underlay pane, which will move the app content to the side.
 * @returns void
 */
export default function toggleDrawerPane(
    paneId: string,
    targetWindow: Window = window,
    showAppUnderlay: boolean = true
): void {
    isDrawerPaneVisible(paneId, targetWindow)
        ? closeDrawerPane(paneId, targetWindow)
        : openDrawerPane(paneId, targetWindow, showAppUnderlay);
}
